import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GptMessage,
  MyMessage,
  TypingLoader,
  TextMessageBox,
} from "../../../components/NewAssistance";
import {
  createThreadUseCasePublic,
  postQuestionUseCase,
  AssistanceApi,
} from "../../../api";
// ⛔ Eliminamos import { useAuth } from "../../../hooks";

const assistanceApiController = new AssistanceApi();

// Componente principal para la nueva asistencia "pública"
export const NewAssistancePublic = () => {
  // 1. Obtener el ID del asistente desde la URL
  const { assistantId } = useParams();

  // 2. Definición de estados
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [threadId, setThreadId] = useState(null);
  const [imageAvatar, setImageAvatar] = useState(null);

  // 3. useEffect: Se ejecuta al montar o cuando cambia assistantId
  useEffect(() => {
    const fetchData = async () => {
      if (!assistantId) {
        console.error("No se proporcionó un ID de asistente en la URL");
        return;
      }

      try {
        // Intentar obtener la imagen del avatar del almacenamiento local
        let storedImagePath = localStorage.getItem(`imageAvatar`);

        if (storedImagePath) {
          // Si ya existe, establecerla en el estado
          setImageAvatar(storedImagePath);
        } else {
          // Si no existe, obtenerla de la API y guardarla en localStorage
          const imagePath =
            await assistanceApiController.getMiniature(assistantId);
          setImageAvatar(imagePath);
          localStorage.setItem(`imageAvatar`, imagePath);
        }

        // Crear un nuevo hilo de conversación sin usar token
        const newThreadId = await createThreadUseCasePublic(assistantId);
        setThreadId(newThreadId);
        localStorage.setItem("threadId", newThreadId);
      } catch (error) {
        console.error("Error en las llamadas asincrónicas:", error);
      }
    };

    fetchData();
  }, [assistantId]);

  // 4. Función para manejar el envío de mensajes
  const handlePost = async (text) => {
    if (!threadId) return;

    // Añadir el mensaje del usuario
    setIsLoading(true);
    setMessages((prev) => [...prev, { text, isGpt: false }]);

    try {
      // Enviar la pregunta y obtener las respuestas (sin token)
      const replies = await postQuestionUseCase(threadId, text, assistantId);
      setIsLoading(false);

      let lastAssistantMessage = null;

      // Extraer la última respuesta del asistente
      for (const reply of replies) {
        if (reply.role === "assistant") {
          lastAssistantMessage = reply.content[reply.content.length - 1];
        }
      }

      if (lastAssistantMessage) {
        setMessages((prev) => [
          ...prev,
          { text: lastAssistantMessage, isGpt: true },
        ]);
      }
    } catch (error) {
      console.error("Error al enviar la pregunta", error);
      setIsLoading(false);
    }
  };

  // 5. Render
  return (
    <div className="chat-container">
      <div className="chat-messages">
        <div className="grid grid-cols-12 gap-y-2">
          <GptMessage
            text="Saludos, soy el tutor de este curso. ¿En qué puedo ayudarte?"
            imageAvatar={imageAvatar}
          />

          {messages.map((message, index) =>
            message.isGpt ? (
              <GptMessage
                key={index}
                text={message.text}
                imageAvatar={imageAvatar}
              />
            ) : (
              <MyMessage key={index} text={message.text} />
            ),
          )}

          {isLoading && (
            <div className="col-start-1 col-end-12 fade-in">
              <TypingLoader />
            </div>
          )}
        </div>
      </div>

      <TextMessageBox
        onSendMessage={handlePost}
        placeholder="Escribe aquí lo que deseas"
        disableCorrections
      />
    </div>
  );
};
